import cn from 'classnames'
import React, { ComponentProps } from 'react'

type TrendLineIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function TrendLineIcon(props: TrendLineIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('TrendLineIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.6667 4.66699H14.6667V8.66699"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6666 4.66699L8.99992 10.3337L5.66659 7.00033L1.33325 11.3337"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
